import databasesApi from '@/api/databases'

export const SET_DATABASES = 'SET_DATABASES'
export const CLEAR_DATABASES = 'CLEAR_DATABASES'

const state = {
  databases: []
}

const getters = {
  getterDatabases: (state) => state.databases
}

const mutations = {
  [SET_DATABASES] (state, values) {
    state.databases = values
  },
  [CLEAR_DATABASES] (state) {
    state.databases = []
  }
}

const actions = {
  actionGetDatabases ({ commit }) {
    return databasesApi.getDatabases()
      .then((response) => {
        commit(SET_DATABASES, response.data)
        return Promise.resolve(response.data)
      })
      .catch((e) => {
        return Promise.reject(e.response.data)
      })
  },
  actionGetDatabase ({ _ }, id) {
    return databasesApi.getDatabase(id)
      .then((response) => {
        return Promise.resolve(response)
      })
      .catch((e) => {
        return Promise.reject(e.response.data)
      })
  },
  actionSaveDatabase ({ _ }, body) {
    return databasesApi.saveDatabase(body)
      .then((response) => {
        return Promise.resolve(response)
      })
      .catch((e) => {
        return Promise.reject(e.response.data)
      })
  },
  actionPutDatabase ({ _ }, id, body) {
    return databasesApi.putDatabase(id, body)
      .then((response) => {
        return Promise.resolve(response)
      })
      .catch((e) => {
        return Promise.reject(e.response.data)
      })
  },
  actionDeleteDatabase ({ _ }, id) {
    return databasesApi.deleteDatabase(id)
      .then((response) => {
        return Promise.resolve(response)
      })
      .catch((e) => {
        return Promise.reject(e.response.data)
      })
  }
}

export default {
  actions,
  state,
  getters,
  mutations
}
